import { useEffect, useState } from "react";
import { CompanyDetailsByCode } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import { useDispatch } from "react-redux";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Nodata from "../../component/common-component/Nodata";

const TermsAndConditionModal = () => {
  const dispatch = useDispatch();
  const [ConditionData, setConditionData] = useState([]);
  const [ConditionLoader, setConditionLoader] = useState(false);

  const getConditionData = async () => {
    setConditionLoader(true);
    dispatch(CompanyDetailsByCode())
      .then((response) => {
        if (response?.payload?.isValidate) {
          setConditionData(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setConditionData([]);
        }
      })
      .finally(() => {
        setConditionLoader(false);
      });
  };
  useEffect(() => {
    getConditionData();
  }, []);
  return (
    <>
      <div>
        <div className="profile-common-title">
          {" "}
          <h3>General Terms & Condtion</h3>
        </div>

        <div className="profile-common">
          <div className="policy-main">
            {ConditionLoader ? (
              <Loader type={LoaderType.FileContent} count={25} />
            ) : (
              <>
                {ConditionData?.qdldevtermandconditions?.length > 0 ? (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: ConditionData?.qdldevtermandconditions,
                    }}
                  />
                ) : (
                  <Nodata />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditionModal;
